import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  useTheme 
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { AdaptiveContainer } from './index';
import { Link } from 'react-router-dom';

const FAQSection = ({
  title,
  questions = [],
  moreQuestionsButton,
  backgroundColor,
  cardBackground,
  titleColor,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ 
      backgroundColor: backgroundColor || theme.palette.background.default
    }} {...props}>
      <AdaptiveContainer>
        <Box
          sx={{
            backgroundColor: cardBackground || theme.palette.background.paper,
            borderRadius: 1,
            boxShadow: theme.shadows[4],
            overflow: "hidden",
            width: "100%",
          }}
        >
          {/* Contenu de la section */}
          <Box sx={{ 
            p: { xs: 3, md: 4, lg: 4 },
          }}>
            
            {/* Titre */}
            <Typography
              variant="h4"
              component="h2"
              sx={{
                fontWeight: 600,
                color: titleColor || theme.palette.primary.main,
                mb: 2,
                textAlign: "left",
                fontSize: { xs: '1.5rem', md: '1.75rem' }
              }}
            >
              {title}
            </Typography>

            {/* Liste des questions FAQ */}
            <Box sx={{ maxWidth: "100%", mx: "auto", mb: 4 }}>
              {questions.map((faq, index) => (
                <Accordion 
                  key={index} 
                  sx={{ 
                    mb: 1,
                    backgroundColor: theme.palette.background.default,
                    '&:last-child': { mb: 0 },
                    borderRadius: 1,
                    '&:before': { display: 'none' } // Supprime la ligne par défaut
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    sx={{
                      backgroundColor: theme.palette.background.default,
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: theme.palette.grey[100],
                      },
                      "& .MuiAccordionSummary-content": {
                        margin: "16px 0",
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ 
                        fontWeight: 600, 
                        color: theme.palette.primary.main,
                        fontSize: { xs: '1rem', md: '1.1rem' }
                      }}
                    >
                      {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails 
                    sx={{ 
                      backgroundColor: "white",
                      pt: 0,
                      pb: 2
                    }}
                  >
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        lineHeight: 1.7,
                        color: theme.palette.text.secondary,
                        fontSize: { xs: '0.9rem', md: '1rem' }
                      }}
                    >
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>

            {/* Bouton "Plus de questions" */}
            {moreQuestionsButton && (
              <Box sx={{ textAlign: "left" }}>
                <Button
                  component={Link}
                  variant="secondary"
                  type='link'
                  to={moreQuestionsButton.to}
                  onClick={moreQuestionsButton.onClick}
                >
                  {moreQuestionsButton.text}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </AdaptiveContainer>
    </Box>
  );
};

export default FAQSection; 